var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loading
        ? _c(
            "Card",
            { staticClass: "vat-settings" },
            [
              _vm.shouldDisplayVatManagerPopup
                ? _c("VatPopupManager", {
                    on: {
                      close: function($event) {
                        _vm.shouldDisplayVatManagerPopup = false
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldDisplayCatRatePopupManager
                ? _c("CatRatePopupManager", {
                    attrs: { rateCategory: _vm.selectedRateCategory },
                    on: {
                      close: function($event) {
                        _vm.shouldDisplayCatRatePopupManager = false
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "vat-settings__default-vat bloc" }, [
                _c("div", { staticClass: "typographies-heading-h3" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("TVA par défaut")))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-3 typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Le taux de TVA par défaut sera utilisé lors de la création des produits et des services."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-row" },
                  [
                    _c(
                      "el-select",
                      {
                        ref: "selectVatByDefault",
                        attrs: { placeholder: "Select" },
                        model: {
                          value: _vm.taxesSettings.vat_id,
                          callback: function($$v) {
                            _vm.$set(_vm.taxesSettings, "vat_id", $$v)
                          },
                          expression: "taxesSettings.vat_id"
                        }
                      },
                      _vm._l(_vm.listNoEcoTaxes, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: _vm._f("taxeLabel")(item),
                            value: item.id,
                            "data-test": "vatoption"
                          }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        type: "tertiary",
                        label: _vm.$t.__("common.actions.edit")
                      },
                      on: {
                        click: function($event) {
                          _vm.shouldDisplayVatManagerPopup = true
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modeTva bloc" },
                [
                  _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Mode de TVA")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mb-3 typographies-paragraph-medium-regular"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "En fonction de la typologie de votre entreprise, choisissez votre mode de TVA. Il sera applicable sur tous vos nouveaux documents."
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "tva-mode-select",
                      attrs: { placeholder: "Select" },
                      model: {
                        value: _vm.taxesSettings.vat_mode,
                        callback: function($$v) {
                          _vm.$set(_vm.taxesSettings, "vat_mode", $$v)
                        },
                        expression: "taxesSettings.vat_mode"
                      }
                    },
                    _vm._l(_vm.tvaModes, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modeTva bloc" },
                [
                  _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Mention du mode de TVA sur les documents de vente"
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mb-3 typographies-paragraph-medium-regular"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Si vous activez cette option, la mention de TVA ci-dessous sera affichée sur les PDF de vos documents de vente."
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("SwitchWithLabel", {
                    ref: "switchTaxMention",
                    attrs: {
                      textLabel: _vm.$t.__(
                        "settings.taxes.VatSettings.activate_VAT_mode_on_sales_documents"
                      ),
                      value: _vm.taxesSettings.display_tax_mention
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateDisplayMention($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pb-1 pt-3 typographies-heading-h4" },
                    [_vm._v(_vm._s(_vm.$l10n.__("Mention")))]
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "inputTaxMention",
                    staticClass: "vat-settings__input-vat-mention",
                    attrs: {
                      disabled: !_vm.taxesSettings.display_tax_mention,
                      maxlength: "255"
                    },
                    model: {
                      value: _vm.taxesSettings.vat_mention,
                      callback: function($$v) {
                        _vm.$set(_vm.taxesSettings, "vat_mention", $$v)
                      },
                      expression: "taxesSettings.vat_mention"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { staticClass: "bloc" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bloc catTarif" },
                [
                  _c("div", { staticClass: "mb-3 typographies-heading-h2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Catégories tarifaires")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("CompassButton", {
                    staticClass: "mb-4",
                    attrs: {
                      "data-upsell": "rate_categories",
                      "data-quota-guard": "rate_categories",
                      disabled: false,
                      label: _vm.$t.__(
                        "settings.taxes.VatSettings.add_price_category"
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.openPopupRateCategory()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "vat-settings-table",
                      attrs: { data: _vm.rateCategories, "max-height": "648" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          className: "pl-3 vat-settings__not-hover",
                          label: "",
                          width: "48"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-radio", {
                                    attrs: { label: scope.row.id },
                                    model: {
                                      value: _vm.taxesSettings.rate_category_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.taxesSettings,
                                          "rate_category_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "taxesSettings.rate_category_id"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          924987168
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.category"
                          ),
                          className: "px-3",
                          prop: "label",
                          sortable: "",
                          width: "219px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "typographies-heading-h4" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(scope.row.label) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  scope.row.price.type === "value"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vat-settings__text_secondary typographies-paragraph-small-regular"
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "Saisie libre du prix"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vat-settings__text_secondary typographies-paragraph-small-regular"
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(scope.row.price.percent) +
                                              "\n                            " +
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  " % sur le prix de référence du produit / service"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3208392727
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.documents"
                          ),
                          className: "px-3",
                          prop: "includes_taxes",
                          sortable: "",
                          width: "133px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.includes_taxes
                                    ? [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$l10n.__("TTC")) +
                                            "\n                        "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$l10n.__("HT")) +
                                            "\n                        "
                                        )
                                      ]
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3103987176
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.VAT_applied"
                          ),
                          className: "px-3",
                          prop: "tva",
                          sortable: "",
                          width: "153px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.labelForTva(scope.row)) +
                                      "\n                    "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3175328684
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.documents_currency"
                          ),
                          className: "px-3",
                          prop: "currency",
                          sortable: "",
                          width: "204px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "typographies-heading-h4" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            scope.row._embed.currency.symbol
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.shouldDisplayIsAccountCurrency(scope.row)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "vat-settings__text_secondary typographies-paragraph-small-regular"
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$l10n.__("Devise du compte")
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          989920298
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t.__("common.labels.accounting_code"),
                          className: "px-3",
                          prop: "accounting_code_id",
                          sortable: "",
                          width: "165px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        scope.row.accounting
                                          .accounting_code_id === null
                                          ? _vm.$l10n.__(
                                              "Code comptable produit"
                                            )
                                          : _vm.getAccountingCodeById(
                                              scope.row.accounting
                                                .accounting_code_id
                                            )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          167761944
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          className: "pl-2 vat-settings__not-hover",
                          width: "52px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-dropdown",
                                    {
                                      attrs: { placement: "bottom-end" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "dropdown",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    staticClass:
                                                      "discount-dropdown"
                                                  },
                                                  [
                                                    _c(
                                                      "el-dropdown-item",
                                                      {
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openPopupRateCategory(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$l10n.__(
                                                                "Editer"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    scope.row.id !=
                                                    _vm.taxesSettings
                                                      .rate_category_id
                                                      ? _c(
                                                          "el-dropdown-item",
                                                          {
                                                            ref:
                                                              "dropdownItemDeleteRateCategory",
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteRateCategory(
                                                                  scope.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  _vm.$l10n.__(
                                                                    "Supprimer"
                                                                  )
                                                                ) +
                                                                "\n                                    "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("CompassIconButton", {
                                        attrs: { icon: "action", size: "small" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          116202555
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bloc vat-settings__default-discount" },
                [
                  _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Remises par défaut")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex-column mb-3 vat-settings__default-discount-select"
                    },
                    [
                      _c("InputWithSelect", {
                        ref: "inputWithSelectDiscount",
                        attrs: { options: _vm.discountOptions },
                        on: { blur: _vm.onBlurVatDiscountValue },
                        model: {
                          value: _vm.vatDiscountValue,
                          callback: function($$v) {
                            _vm.vatDiscountValue = $$v
                          },
                          expression: "vatDiscountValue"
                        }
                      }),
                      _vm._v(" "),
                      _vm.displayErrorOnInputDiscount
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pt-1 typographies-paragraph-small-regular vat-settings__text_error"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Merci de rentrer une valeur valide (pas plus de deux décimals)"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("SwitchWithLabel", {
                    ref: "switchByRows",
                    attrs: {
                      textLabel: _vm.$t.__(
                        "settings.taxes.VatSettings.each_product__can_have_specific_discount"
                      ),
                      value: _vm.taxesSettings.discount.by_rows
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateDiscountByRow($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bloc ecotax" },
                [
                  _c("div", { staticClass: "mb-3 typographies-heading-h3" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Écotaxe")))
                  ]),
                  _vm._v(" "),
                  _c("SwitchWithLabel", {
                    attrs: {
                      textLabel: _vm.$t.__(
                        "settings.taxes.VatSettings.enable_eco_tax"
                      ),
                      value: _vm.taxesSettings.use_ecotax
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateUseEcotax($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bloc discountTTC" },
                [
                  _c(
                    "div",
                    { staticClass: "bloc mb-3 typographies-heading-h3" },
                    [_vm._v(_vm._s(_vm.$l10n.__("Remise TTC")))]
                  ),
                  _vm._v(" "),
                  _c("SwitchWithLabel", {
                    attrs: {
                      textLabel: _vm.$t.__(
                        "settings.taxes.VatSettings.enable_discount_including_tax"
                      ),
                      value: _vm.taxesSettings.use_bonuses
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateUseBonuses($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }